<div>
    <div class="alert alert-success text-center" role="alert">
        <div *ngIf="waiting" class="alert-text">{{waitMessage}}
        </div>
        <div *ngIf="!waiting" class="alert-text">{{successfulMessage}}
        </div>
    </div>
</div>
